import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./notes/event_hub.js